import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
})
export class PaginatorComponent {
  INITIAL_PAGE = 1;

  @Input() pages: [];

  @Input() currentPage = 1;

  @Input() totalPages: number;

  @Output() pageChange = new EventEmitter<number>();

  changeCurrentPage(targetPage: number): void {
    if (targetPage < this.INITIAL_PAGE || targetPage > this.totalPages) {
      return;
    }

    this.currentPage = targetPage;

    this.pageChange.emit(targetPage);
  }

  walkToPriorPage = (): void => this.changeCurrentPage(this.currentPage - 1);

  walkToNextPage = (): void => this.changeCurrentPage(this.currentPage + 1);
}
